import FinishProposalPaymentType from './FinishProposalPaymentType';

export default FinishProposalPaymentType;
